import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RankComponent } from './rank.component';
import { SafePipe } from './safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RatingsService } from './../ratings.service';
import { reducers } from './../ngrx/reducers';
import { RatingsEffects } from './../ngrx/effects';



@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    StoreModule.forFeature(RatingsService.featureName, reducers),
    EffectsModule.forFeature([RatingsEffects]),
  ],
  exports: [
    RankComponent
      ],
  declarations: [RankComponent, SafePipe],
  providers: [
    RatingsService
  ]
})
export class RankModule { }
